module.exports = __webpack_public_path__ + "static/media/doctor_patientcall-1200.06319661.webp";